    package com.cybersoftsolution.cybersoftsolutionweb.utils

    import org.jetbrains.compose.web.css.px

    object IdConst {

        val sidePanelInternalWidth = 350.px
        val sidePanelCollapsedHeight = 50.px
        val headerSectionHeight = 84.px
        const val userEmailTextField = "userEmailTextField"
        const val userNameTextField = "userNameTextField"
        const val otpTextFieldId = "otpTextFieldId"
        const val passwordTextFieldId = "passwordTextFieldId"
        const val newPasswordTextFieldId = "newPasswordTextFieldId"
        const val confirmNewPasswordTextFieldId = "confirmNewPasswordTextFieldId"
        const val forgotPasswordText = "forgotPasswordText"
        const val errorText = "errorText"
        const val checkBoxRememberLogin = "checkboxRememberLogin"


        const val navigationIcon = "navigationIcon"
        const val svgParentIcon = "svgParentIcon"
        const val vectorIcon = "vectorIcon"
        const val navigationText = "navigationText"
        const val primaryButtonId = "primaryButtonId"
        const val checkBoxId = "checkBoxId"
        const val titleId = "titleId"
        const val searchTextFieldId = "searchTextFieldId"
        const val subTitleId = "subTitleId"
        const val imagenFieldNameId = "imagenFieldNameId"
        const val categoryDropDownId = "categoryDropDownId"
        const val emailProviderDropDownId = "emailProviderDropDownId"
        const val expirationTimesDropDownId = "expirationTimesDropDownId"
        const val upploadButtonId = "upploadButtonId"
        const val deletePostsButtonId = "deletePostsButtonId"
        const val previewButtonId = "previewButtonId"
        const val editorId = "textEditorId"
        const val editorIdPreview = "_preview"
        const val createButtonId = "createButtonId"
        const val loginButtonId = "loginButtonId"
        const val forgotPasswordButtonId = "forgotPasswordButtonId"
        const val restorePasswordButtonId = "restorePasswordButtonId"
        const val googleAuthButtonId = "googleAuthButtonId"
        const val returnButtonId = "returnButtonId"
        const val logoutButtonId = "logoutButtonId"
        const val registerButtonId = "registerButtonId"
        const val otpExpireInSecTextId = "otpExpireInSecTextId"
        const val toastBasicID = "toastBasicID"
        const val toastActionDeleteID = "toastActionDeleteID"


    }